<template>
  <div v-if="show">
  <b-row>
      <b-col>
        <h3>{{ index }}.2 Allocazione consumi {{ vectorName }}</h3>
        <p>Si riporta ripartizione dei consumi secondo le macroaree definite nel D.Lgs 102/14.<br>
        I dati si intendono relativi al mese in analisi:</p>
      </b-col>
    </b-row>

    <table class="grid">
      <tr>
        <td class="col-small">
          <div class="pie-wrap">
            <apexchart type="pie" :options="pie_options" :series="pie_data" />
          </div>
        </td>
        <td class="report-arrow"><img src="/static/report/arrow.png"></td>
        <td class="col-small2">
          <b-table class="last-bold" :fields="fields" :items="items">
            <template slot="color" slot-scope="row">
              <span v-if="! row.item.isTotal" class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
            </template>
          </b-table>
        </td>
      </tr>
    </table>

    <b-row>
      <b-col>
        <apexchart type="bar" :options="bar_options" :series="bar_series" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
var moment = require('moment');

export default {
  name: "SummaryCategories",
  props: ['siteGuid', 'month', 'vector', 'index'],

  data() {
    return {
      currentYear: 0,
      show: false,
      chart: {
        options: {
          chart: {
            animations: {
              enabled: false
            }
          },
          xaxis: {
            categories: []
          },
          dataLabels: {
            enabled: false
          }
        },
        series: []
      },
      pie_options: {
        colors: this.$store.state.colors,
        chart: {
          animations: { enabled: false },
          width: 300,
        },
        labels: [],
        legend: { show: false }
      },
      pie_data: [],
      bar_options: {
        colors: this.$store.state.colors,
        chart: {
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          },
          stacked: true,
          height: 300,
          width: 940,
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            formatter: (v) => this.f(v)
          }
        },
      },
      bar_series: [],
      fields: [{ key: "color", label: "" }, { key: "category", label: "" }, { key: "value", label: this.vectorMu() }],
      items: []
    }
  },

  created() {
    this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))
    var params = {
      fromMonth: '01-' + this.currentYear,
      toMonth: '12-' + this.currentYear,
      siteGuid: this.siteGuid,
      vector: this.vector
    }

    this.pie_data = []
    this.$store.dispatch('report/categories', params).then(data => {

      var categories = _.filter(_.uniq(data.items.map(e => e.category), (e) => e != null))

      if(categories.length > 0) {
        this.show = true
        var pieOptions = _.cloneDeep(this.pie_options)
        var currentMonth = _.filter(data.items, (e) => e.date == this.month)

        var all = 0
        categories.forEach(c => {
          pieOptions.labels.push(c)
          this.pie_data.push(currentMonth.find(e => e.category == c).value)

          var tot = 0
          _.filter(data.items, (e) => e.category == c).forEach(e => tot += e.value)

          this.items.push({ category: c, value: this.f(tot) })

          this.bar_series.push({ name: c, data: [] })
          all += tot
        })

        this.items.push({ category: 'Totale', value: this.f(all), isTotal: true })

        this.pie_options = pieOptions

        var barOptions = _.cloneDeep(this.bar_options)
        for(let i=1; i<=12; i++) {
          var month = i.toString().padStart(2, "0") + "-" + this.currentYear
          barOptions.xaxis.categories.push(moment(month, "MM-YYYY").format("MMM"))

          categories.forEach(c => {
            var item = data.items.find(e => e.date == month && e.category == c)
            var serie = this.bar_series.find(s => s.name == c)
            serie.data.push(item ? item.value : null)
          })
        }
        this.bar_options = barOptions
      }
    })
  },

  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    vectorMu() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).mu
    }
  },

  computed: {
    vectorName() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).name
    },

  }
}
</script>

<style>
table.last-bold tr:last-of-type td {
  font-weight: bold;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/E1_Summary.vue